module.exports = __webpack_public_path__ + "img/DW365-140.2576fa17.jpg";